import { useState, useEffect, useRef } from "react";
import "./hero.css";
import cloudLeft from "../../assets/vector/Vector-8.png";
import cloudTop from "../../assets/vector/Vector-7.png";
import cloudRight from "../../assets/vector/Vector-4.png";
import RYSEMundo from "../../assets/images/RYSEMundo.mp4";
import LiveVideoModalGIF from "../../components/layout/LiveVideoModal_GIF";

const BLOB_BASE = "https://rysevideos-cehgedfjh3fbetev.z01.azurefd.net/videos/";

const LANG_OPTIONS = [
  {
    id: "en",
    label: "English — RYSE in Action",
    title: "RYSE in Action",
    file: "f_Ryse_Agents_720p_CROPPED.mp4"
  },
  {
    id: "zh",
    label: "中文 — RYSE 演示",
    title: "RYSE 演示",
    file: "f_RyseAgentsChinese_720p_CROPPED1.mp4"
  },
  {
    id: "fr",
    label: "Français — Démo RYSE",
    title: "Démo RYSE",
    file: "f_RyseAgentsFrench_720p_Cropped.mp4"
  },
  {
    id: "ar",
    label: "العربية — عرض RYSE",
    title: "عرض RYSE",
    file: "f_RyseAgentsArabic.mp4"
  },
  {
    id: "de",
    label: "Deutsch — RYSE Demo",
    title: "RYSE Demo",
    file: "f_RyseAgentsGerman_720p.mp4"
  },
  {
    id: "hi",
    label: "हिन्दी — RYSE डेमो",
    title: "RYSE डेमो",
    file: "f_RyseAgentsHindi_720p.mp4"
  },
  {
    id: "ja",
    label: "日本語 — RYSE デモ",
    title: "RYSE デモ",
    file: "f_RyseAgentsJapan_720p.mp4"
  },
  {
    id: "sw",
    label: "Kiswahili — Onyesho la RYSE",
    title: "Onyesho la RYSE",
    file: "f_RyseAgentsSwahili_720p.mp4"
  },
  {
    id: "el",
    label: "Ελληνικά — Παρουσίαση RYSE",
    title: "Παρουσίαση RYSE",
    file: "f_RyseAgentsGreek_720p.mp4"
  },
  {
    id: "it",
    label: "Italiano — Demo RYSE",
    title: "Demo RYSE",
    file: "f_RyseAgentsItalian_720p.mp4"
  }
];


export default function HeroSection() {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedLang, setSelectedLang] = useState(null);
  

  const openVideo = (title, filename) => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

return (
    <section className="hero-ryse">
      <img
        src={cloudLeft}
        alt=""
        className="hero-ryse__cloud hero-ryse__cloud--left hide_mobile"
      />
      <img
        src={cloudTop}
        alt=""
        className="hero-ryse__cloud hero-ryse__cloud--top"
      />
      <img
        src={cloudRight}
        alt=""
        className="hero-ryse__cloud hero-ryse__cloud--right"
      />

      <div className="hero-ryse__inner">
        <div className="hero-ryse__content">
          <h1 className="hero-ryse__headline">
            A next-generation analytics platform built to merge advanced
            financial mathematics with secure, enterprise-grade artificial
            intelligence
          </h1>
          {/* ✅ Language selector + single action button */}
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginTop: 24 }}>
            {/* Label */}
            <div style={{ color: "#cccccc", fontSize: 14 }}>
              
            </div>
            <select
              value={selectedLang?.id || ""}
              onChange={(e) => {
                const lang = LANG_OPTIONS.find((l) => l.id === e.target.value);
                setSelectedLang(lang);
                setIsModalOpen(true);
              }}
              style={{
                width: 200,
                padding: "10px 12px",
                borderRadius: 10,
                border: "1px solid rgba(255,255,255,0.18)",
                background: "rgba(0,0,0,0.35)",
                color: "#fff",
                outline: "none"
              }}
            >
            <option value="" disabled style={{ color: "#000" }}>
              RYSE in Action
            </option>              
              {LANG_OPTIONS.map((lang) => (
                <option key={lang.id} value={lang.id} style={{ color: "#000" }}>
                  {lang.label}
                </option>
              ))}
            </select>


          </div>  
        </div>

        <div className="hero-ryse__visual">
          <video
            className="hero-ryse__globe"
            src={RYSEMundo}
            muted
            autoPlay
            loop
            playsInline
            aria-label="Ryse globe"
          />
        </div>
      </div>

      {/* ✅ Azure-hosted MP4 in your GIF-loading modal */}
      <LiveVideoModalGIF
        open={isModalOpen}
        onClose={closeModal}
        title={selectedLang?.title || ""}
        url={selectedLang ? BLOB_BASE + selectedLang.file : ""}
        language={selectedLang?.id || ""}
      />
    </section>
  );
}



